const { REACT_APP_API_BASE_URL } = process.env;

export const convertExcelToPDF = (token, excelFile) => new Promise((resolve, reject) => {
  const formData = new FormData();
  formData.append('excel', excelFile);

  const request = new Request(`${REACT_APP_API_BASE_URL}/excel/convert`, {
    method: 'POST',
    body: formData,
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });

  fetch(request)
    .then(response => {
      if (!response.ok) {
        return reject(new Error('Error en la conversión: ' + response.statusText));
      }
      return response.blob(); // Recibimos el PDF como archivo (Blob)
    })
    .then(blob => resolve(blob))
    .catch(err => reject(err));
});